export const STORY_FONTS = {
  default: { label: 'Default (Georgia)', family: 'Georgia, serif' },
  lexend: { label: 'Lexend', family: "'Lexend', system-ui, sans-serif" },
  'source-serif': { label: 'Source Serif 4', family: "'Source Serif 4', Georgia, serif" },
} as const

export type StoryFontId = keyof typeof STORY_FONTS

export function isStoryFontId(value: unknown): value is StoryFontId {
  return typeof value === 'string' && Object.hasOwn(STORY_FONTS, value)
}
